import { runpod_permission } from "./runpod.permission";

export const impact_narrative_permission = {
    required_permission: ['view_impactnarrative', 'add_impactnarrative', 'change_impactnarrative', "view_response"],
    runpod_permission: runpod_permission?.required_permission
}